import {useState, useEffect} from 'react';

import {useParams} from 'react-router';

import {getPublicCBLocations} from 'api/certification-bodies';
import {alertByError} from 'utils/alerts';

const useGetCBKeyLocation = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const {cbId} = useParams();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      const {data} = await getPublicCBLocations(cbId);

      setData(data);
    } catch (error) {
      alertByError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {isLoading, data};
};

export default useGetCBKeyLocation;
